module.exports = __webpack_public_path__ + "static/media/creditcard-clicked.7cd5b99f.png";